// Actions
export const HEALTH_COMPLEMENTARY_ACTIONS = {
    SET_LABEL: 'SET_COMPLEMENTARY_LABEL',
    SET_NUM_ID: 'SET_NUM_ID',
    SET_ADDRESS: 'SET_ADDRESS',
    CLEAR_INPUT: 'CLEAR_INPUT',
    SET_IS_AME: 'SET_IS_AME',
    SET_IS_CSS: 'SET_IS_CSS',
    SET_IS_SPECIAL: 'SET_IS_SPECIAL',
    FETCH_HEALTH_COMPLEMENTARY: 'FETCH_HEALTH_COMPLEMENTARY',
}

// Initial state
export const getComplementaryInitialState = ({ initHealthComplementary }) => {
    if (initHealthComplementary) {
        return {
            ...initHealthComplementary,
        }
    } else {
        return {
            label: '',
            numId: '',
            address: null,
            isSpecial: false,
            isCSS: false,
            isAME: false,
        }
    }
}

// Reducer
export const healthComplementaryFormReducer = (state, action) => {
    switch (action.type) {
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_LABEL:
            return {
                ...state,
                label: action.payload,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_NUM_ID:
            return {
                ...state,
                numId: action.payload,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_ADDRESS:
            return {
                ...state,
                address: {
                    ...state.address,
                    ...action.payload,
                },
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.CLEAR_INPUT:
            return {
                label: '',
                numId: '',
                address: null,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_IS_AME:
            return {
                ...state,
                isAME: action.payload,
                isCSS: false,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_IS_CSS:
            return {
                ...state,
                isCSS: action.payload,
                isAME: false,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.SET_IS_SPECIAL:
            return {
                ...state,
                isSpecial: action.payload,
                isCSS: false,
                isAME: false,
            }
        case HEALTH_COMPLEMENTARY_ACTIONS.FETCH_HEALTH_COMPLEMENTARY:
            if (action.payload.address) {
                // remove the id from the address
                action.payload.address.id = undefined
                action.payload.address['@id'] = undefined
            }
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}
